import { render, staticRenderFns } from "./shipped-tracking.vue?vue&type=template&id=d3fa5254&"
import script from "./shipped-tracking.vue?vue&type=script&lang=js&"
export * from "./shipped-tracking.vue?vue&type=script&lang=js&"
import style0 from "./shipped-tracking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports